import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UseCaseTypesEnum } from '@vi-iot/client';

@Pipe({
  name: 'translateUseCaseType',
})
export class TranslateUseCaseTypePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(useCaseType: UseCaseTypesEnum): string {
    switch (useCaseType) {
      case UseCaseTypesEnum.ConfigurationOverview:
        return `${this.translate.instant('DIAGNOSTICS.USE_CASE_TYPE.CONFIGURATION_OVERVIEW')}`;
      case UseCaseTypesEnum.DiagnosisOverview:
        return `${this.translate.instant('DIAGNOSTICS.USE_CASE_TYPE.DIAGNOSIS_OVERVIEW')}`;
      case UseCaseTypesEnum.InspectionDashboard:
        return `${this.translate.instant('DIAGNOSTICS.USE_CASE_TYPE.INSPECTION_DASHBOARD')}`;
    }
  }
}
